import { useNavigate } from "@tanstack/react-router";
import React from "react";
import { useAuth } from "../../../utils/auth";
import { useDiariesByPatientQuery } from "../api";

const useNavigateToDiary = () => {
    const navigate = useNavigate();

    const auth = useAuth();
    const patientId = auth && typeof auth.id === "string" ? auth.id : null;
    const { data: diaries = [] } = useDiariesByPatientQuery(patientId ?? "");

    const navigateToDiary = () => {
        if (diaries.length === 1) {
            navigate({
                to: "/diaries/$diaryId/home/new",
                params: { diaryId: diaries?.[0]?.diary_id },
            });
            return;
        }
        navigate({ to: "/diaries" });
    };
    return {
        diaryWord: diaries.length === 1 ? "Diary" : "Diaries",
        navigateToDiary,
    };
};

export default useNavigateToDiary;
